import { useState } from 'react';
import PlansTabs from 'components/plans/PlansTabs';
import * as Tabs from '@radix-ui/react-tabs';
import PlanModal from 'components/plans/PlanModal';
import PlansHeader from 'components/plans/PlansHeader';

export default function Plans() {   
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('plans');

    return (
        <div className="px-6 pb-3 overflow-hidden overflow-y-auto h-full">
            <div className="pt-6 ">
                <PlansHeader />
            </div>

            <Tabs.Root defaultValue="plans" onValueChange={setActiveTab}>
                <PlansTabs 
                    activeTab={activeTab} 
                    onTabChange={setActiveTab} 
                />
            </Tabs.Root>

            <PlanModal
                isOpen={isCreateModalOpen}
                onClose={() => setIsCreateModalOpen(false)}
                mode="create"
            />
        </div>
    );
} 